import { baseURL, formatFetchError } from '@/api/util'
import { defaultPostHeader } from '@/settings'
import type { Auth } from '@/types'

export async function signIn(data: Auth.SignInRequest): Promise<Auth.AuthResponse> {
  try {
    const res = await fetch(`${baseURL}/auth/signin`, {
      method: 'POST',
      headers: defaultPostHeader,
      body: JSON.stringify(data),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function newPassword(data: Auth.NewPasswordRequest): Promise<Auth.AuthResponse> {
  try {
    const res = await fetch(`${baseURL}/auth/new-password`, {
      method: 'POST',
      headers: defaultPostHeader,
      body: JSON.stringify(data),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function renewAccessToken(refresh_token: string): Promise<Auth.AuthResponse> {
  try {
    const res = await fetch(`${baseURL}/auth/renew`, {
      method: 'POST',
      headers: defaultPostHeader,
      body: JSON.stringify({ refresh_token }),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function forgotPassword(data: Auth.ForgotPasswordRequest): Promise<Auth.AuthResponse> {
  try {
    const res = await fetch(`${baseURL}/auth/forgot-password`, {
      method: 'POST',
      headers: defaultPostHeader,
      body: JSON.stringify(data),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function confirmForgotPassword(data: Auth.ConfirmForgotPasswordRequest): Promise<Auth.AuthResponse> {
  try {
    const res = await fetch(`${baseURL}/auth/confirm-forgot-password`, {
      method: 'POST',
      headers: defaultPostHeader,
      body: JSON.stringify(data),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
